import React from "react";

// One platform mark for marketing, authentication, and the signed-in app.
export default function BrandMark({ size = 40, tile = false }) {
  return <img src="/images/life-circle-mark.svg" alt="" aria-hidden="true" width={size} height={size}
    style={{ display: "block", flexShrink: 0, objectFit: "contain", ...(tile ? { background: "#fffdf7", borderRadius: 14, padding: 6 } : {}) }} />;
}
